"use client";

import React, { useEffect } from "react";
import { useGetAllRoles } from "@/hooks/user/use-role";
import { roleStore } from "@/store/user/role-store";
import RolesTable from "@/components/settings/roles-table";

const RolesPage: React.FC = () => {
    const { setRoles } = roleStore();
    const { data, isPending } = useGetAllRoles();
    useEffect(() => {
        if (data) {
            setRoles(data);
        }
    }, [data]);

    return (
        <div className="">
            {isPending ? (
                <p className="h-full flex justify-center items-center">Fetching Roles...</p>
            ) : (
                <RolesTable />
            )}
        </div>
    );
};

export default RolesPage;